import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Nav from "./Components/Nav/nav";
import Home from "./Components/Home/home";
import Account from "./Components/Account/account";
import Login from "./Components/Login/login";
import Register from "./Components/Register/register";
import DSASheet from "./Components/DSASheet/dsaSheet";
import Notes from "./Components/Notes/notes";
import Images from "./Components/Images/images";
import Contact from "./Components/Contact/contact";
import ForgetPassword from "./Components/ForgetPassword/forgetpassword";
import Reset from "./Components/Reset/reset";
import Problems from "./Components/Problems/problems";

function App() {
  return (
    <div className="App bg-slate-50 min-h-screen">
      <Router>
        <Nav>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/problems" element={<Problems />} />
            <Route path="/account" element={<Account />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/dsasheet" element={<DSASheet />} />
            <Route path="/notes" element={<Notes />} />
            <Route path="/images" element={<Images />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/forgetpassword" element={<ForgetPassword />} />
            <Route path="/reset" element={<Reset />} />
          </Routes>
        </Nav>
      </Router>
    </div>
  );
}

export default App;